import { useQuery } from '@tanstack/react-query';
import { useParams } from '@/providers/RouterShim';

import type { ApiResponse } from '../../@types/ApiResponse';
import type { Assignment } from '../../@types/Assignment';
import type { ElasticSearchResponse } from '../../@types/ElasticSearchResponse';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';
import usePermissionAssignment from '../permissions/usePermissionAssignment';

export const ASSIGNMENTS_NOTIFICATION_QUERY = '/api/assignments/hits';

const queryfilter = encodeURIComponent('assignmentStatus=Published&recipientStatus=Pending&hits=0');

const useAssignmentsNotificationCount = (): number | undefined => {
  const { getToken } = useAuth();
  const { branchId } = useParams();
  const [permission] = usePermissionAssignment();

  const { data } = useQuery<ApiResponse<ElasticSearchResponse<Assignment>>>({
    queryKey: [ASSIGNMENTS_NOTIFICATION_QUERY, branchId],
    queryFn: async () =>
      getJSON<ApiResponse<ElasticSearchResponse<Assignment>>>(
        `/api/${branchId}/assignments?filter=${queryfilter}`,
        getToken(),
      ),
    refetchInterval: 100 * 1000,
    enabled: !!permission?.enabled && !!branchId,
  });

  const count = permission?.enabled ? data?.response.documentList.numberOfHits : undefined;

  return count;
};

export default useAssignmentsNotificationCount;
